import React from 'react'
import EventCount from 'components/Cms/EventCount'
import { IBadgeProps } from '../types'

const CmsEventBadge: React.FC<IBadgeProps> = ({ badge, dataTestId }) => (
  <EventCount numberOfEvents={badge.numberOfEvents} dataTestId={dataTestId} />
)

export default CmsEventBadge
